import { ApprovalItemLiteModel } from 'api-hooks/approval-item';
import { NavigationRoutes } from 'common/constants';
import { PaginationMeta } from 'common/repositories/common.model';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import { TableContainer } from 'components/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  approval: ApprovalItemLiteModel[];
  loading?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  meta?: PaginationMeta;
  sortColumns: IColumn<any>[];
}

export default function ApprovalItemTable(props: Props) {
  const { approval, sortColumns, loading, page, onPageChange, meta } = props;
  const { t } = useTranslation();

  const columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'index',
        stickyLeft: true,
        minSize: 40,
        maxSize: 40,
        cell: ({ row }) => {
          return (
            <>
              {row.index +
                1 +
                ((meta?.currentPage || 1) - 1) * (meta?.perPage || 1)}
            </>
          );
        },
      },
      ...sortColumns,
    ],
    [meta?.currentPage, meta?.perPage, sortColumns],
  );

  return (
    <>
      <TableContainer>
        <TableComponent
          columns={columns}
          isLoading={loading}
          data={approval || []}
          rowLink={(row) => {
            return {
              pathname: NavigationRoutes.ApprovalItemsView,
              query: {
                id: row.original.id,
                title: [t('common:approval'), row.original.number].join(' - '),
              },
            };
          }}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={onPageChange}
        meta={meta}
      />
    </>
  );
}
